<template>
  <div class="userDistribution">
    <div class="owner">
      <p class="big_title">{{platformName}}带来车主</p>
      <el-radio-group v-model="userDistribution.timeType" @change="timeTypeChange">
        <el-radio-button v-for="item in timeOption" :key="item.code" :label="item.code">{{item.desc}}</el-radio-button>
      </el-radio-group>
      <el-date-picker
        class="date-picker"
        v-model="userDistribution.dataTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"   
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="formTimeChange"
        :picker-options="pickerOptions"
        :editable="false">
      </el-date-picker>
      <div id="userDistribution_chart"></div>
      <div class="data_box">
        <el-tooltip class="item" effect="light" content="到站率=到站用户数/给贵站用户数*100% ">
          <span class="title">{{platformName}}用户到站率 <i class="el-icon-question"></i></span>
        </el-tooltip>
        <span class="num">{{numProcessing(resultData.arriveRate)}}%</span>
        <span class="msg" v-if="userDistribution.timeType===1">较上一日</span>
        <span class="msg" v-else>较上周期</span>
        <img :src="getIcon(resultData.compareYesterdayRate)">
        <span :class="['per', getClass(resultData.compareYesterdayRate)]">{{numProcessing(resultData.compareYesterdayRate)}}%</span>
      </div>
    </div>
    <div class="table">
      <p class="big_title">实时行为</p>
      <el-table
        :data="tableData"
        height="300"
        style="width: 100%">
        <el-table-column
          prop="phone"
          align="center"
          label="用户手机号">
        </el-table-column>
        <el-table-column
          prop="event"
          align="center"
          label="触发行为">
        </el-table-column>
        <el-table-column
          prop="eventTime"
          align="center"
          label="时间">
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom_box">
      <img class="robot" src="../../../assets/image/workPlatform/robot.png" alt="">
      <div class="rightBox">
        <p class="msg" :title="resultData.businessAnalysis">经营分析：{{resultData.businessAnalysis}}</p>
        <div class="btn_box">
          <span class="btn" @click="signUp" v-if="btnJurisdiction.isReport">去报名</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import echarts from 'echarts'
import rise from '../../../assets/image/workPlatform/rise.png'
import fall from '../../../assets/image/workPlatform/fall.png'
import { getUserDistribution, getRealTimeBehavior } from '@/api/businessAnalysis'
import { mapGetters } from 'vuex'

export default {
  props: {
    btnJurisdiction: {
      type: Object,
      default () {
        return {}
      }
    },
    time: {
      type: Number,
      default : 3000
    }
  },
  data () {
    return {
      gasId: '',
      echartsDom: null,
      timmer: null,
      userDistribution: {
        timeType: 1,
        dataTime: []
      },
      timeOption: [
        {
          code: 1,
          desc: '昨日'
        },
        {
          code: 2,
          desc: '近7天'
        },
        {
          code: 3,
          desc: '近30天'
        }
      ],
      tableData: [],
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate)
        },
        disabledDate:(time)=> {
          let date = dayjs('2022-06-01')
          let startTime = time.getTime() < dayjs(date).valueOf()
          let endTime = time.getTime() > dayjs().subtract(1, 'day').valueOf()
          return startTime || endTime
        }  
      },
      resultData: {},
      // isSdLogin: JSON.parse(sessionStorage.getItem('isSdLogin'))
    }
  },
  computed: {
    ...mapGetters(['platformName'])
  },
  methods: {
    // 图标
    getIcon (num) {
      if (num > 0) return rise
      if (num < 0) return fall
    },
    // 类名 
    getClass (num) {
      if (num > 0) return 'red'
      if (num < 0) return 'green'
    },
    numProcessing (num) {
      if (num || num === 0) {
        return Math.abs(num * 100).toFixed(2)
      } else {
        return '-'
      }
    },
    init (gasId) {
      this.gasId = gasId
      this.getUserDistribution()
      this.getRealTimeBehavior()
      clearInterval(this.timmer)
      this.timmer = window.setInterval(() => {
        this.getRealTimeBehavior()
      }, this.time*1000)
    },
    signUp () {
      this.$router.push({path: '/promotion/centerShow'})
    },
    drawLine () {
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('userDistribution_chart'))
      this.echartsDom.setOption({
        color: ['#f8f8fc', '#d2daf7'],
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          textStyle: {
            color: '#606266'
          },
          formatter: (param) => {
            let index = param.dataIndex
            let data = ''
            if (index === 0) {
              data = '在app或小程序上查看过您油站的用户数' 
            }
            return data
          },
          padding: [10,16],
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        // gap: 5,
        legend: {
          data: [`${this.platformName}给贵站用户数`, '到站用户数'],
          show: false
        },
        series: [
          {
            name: 'Funnel',
            type: 'funnel',
            // left: '10%',
            top: 30,
            bottom: 0,
            // width: '80%',
            min: 0,
            // max: 100,
            minSize: '30%',
            maxSize: '100%',
            sort: 'descending',
            gap: 4,
            label: {
              show: true,
              position: 'inside',
              formatter: (param) => {
                let key = param.dataIndex ? 'arriveGasUserCount' : 'exposureUserCount'
                let html = `{a|${param.data.name}}\n{b|${this.geUnit(this.resultData[key]).num}}{c|${this.geUnit(this.resultData[key]).unit}}`
                return html
              },
              rich: {
                a: {
                  color: '#606266',
                  fontSize: 14,
                  lineHeight: 24
                },
                b: {
                  color: '#1E1F22',
                  fontFamily: 'Roboto',
                  fontWeight: 400,
                  fontSize: 24,
                },
                c: {
                  color: '#1E1F22',
                  fontFamily: 'Roboto',
                  fontWeight: 400,
                  fontSize: 16,
                }
              },
              color: '#606266'
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#dfe3ef',
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: [
              { value: 100, name: `${this.platformName}给贵站用户数` },
              { value: 50, name: '到站用户数' }
            ]
          }
        ]
      })
    },
    // 单位
    geUnit (num) {
      let number = num || num === 0 ? (num >= 1000000 ? Math.round(num/100)/100 : num) : '-'
      return {
        num: number,
        unit: num >= 1000000 ? '万人' : '人'
      }
    },
    timeTypeChange() {
      this.$track.clickEvent('经营分析-时间组件', 1655798957)
      this.userDistribution.dataTime = []
      this.getUserDistribution()
    },
    formTimeChange () {
      this.$track.clickEvent('经营分析-时间组件', 1655798957)
      if (this.userDistribution.dataTime && this.userDistribution.dataTime.length) {
        this.userDistribution.timeType = -1
      } else {
        this.userDistribution.timeType = 1
      }
      this.getUserDistribution()
    },
    async getUserDistribution () {
      try {
        let data = {
          gasId: this.gasId,
          queryType: this.userDistribution.timeType
        }
        if (this.userDistribution.dataTime && this.userDistribution.dataTime.length) {
          data.beginDate = this.userDistribution.dataTime[0]
          data.endDate = this.userDistribution.dataTime[1]
        }
        const { code, result } = await getUserDistribution(data)
        if (code !== 200) return
        this.resultData = result
        this.drawLine()
      } catch (error) {
        console.log(error)
      }
    },
    async getRealTimeBehavior () {
      try {
        const { code, result } = await getRealTimeBehavior({ gasId: this.gasId })
        if (code !== 200) return
        this.tableData = result.realTimeActions
      } catch (error) {
        console.log(error)
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timmer)
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
#userDistribution_chart {
  width: 100%;
  height: 180px;
}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
/deep/.el-radio-group {
  // margin-left: 8px;
  margin-right: 8px;
}
/deep/.el-range-editor.el-input__inner {
  padding: 0 10px;
}
</style>